import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"

export default function BNGBetRace() {
  const data = promotionsData.find((promo) => promo.title === "BNG Bet Race")
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> BNG Bet Race </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> /{" "}
              <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1> BNG Bet Race </h1>
                  <h2> Total Prize: ₱2,200,000 </h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period </strong>
                    <span> January 01 (12PM) - January 08 (12PM) </span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong> Campaign Details </strong>
                  <ol>
                    <li>
                      <strong className="highlight">
                        Games Participating:{" "}
                      </strong>
                      All eligible BNG games.
                    </li>
                    <li>
                      <strong className="highlight">Period: </strong> 2026-01-01
                      12:00 PM UTC+8 ~ 2026-01-08 12:00 PM UTC+8.
                    </li>
                    <li>
                      <strong className="highlight">Qualification: </strong>
                      Play at BNG games for at{" "}
                      <strong className="highlight">
                        least 1 rounds with minimum 1.1 PHP bet.
                      </strong>
                    </li>
                    <li>
                      <strong className="highlight">
                        Point Calcuation: Based on the amount of bets in each
                        macro spin.
                      </strong>
                    </li>
                    <ul
                      className="no-desc-style"
                      style={{ marginBottom: "0px" }}
                    >
                      <li>1. Bet 55 PHP＝1 Point.</li>
                    </ul>
                    <ul
                      className="no-desc-style"
                      style={{ marginBottom: "0px" }}
                    >
                      <li>
                        2. For example : The player bet 550 PHP in a round, and
                        he/she gets 10 points in this round
                      </li>
                    </ul>
                  </ol>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <th>Rank</th>
                        <th>Prize</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1st</td>
                          <td>₱440,000</td>
                        </tr>
                        <tr>
                          <td>2nd</td>
                          <td>₱220,000</td>
                        </tr>
                        <tr>
                          <td>3rd</td>
                          <td>₱110,000</td>
                        </tr>
                        <tr>
                          <td>4th-5th</td>
                          <td>₱55,000</td>
                        </tr>
                        <tr>
                          <td>6th-10th</td>
                          <td>₱22,000</td>
                        </tr>
                        <tr>
                          <td>11th-50th</td>
                          <td>₱11,000</td>
                        </tr>
                        <tr>
                          <td>51st-100th</td>
                          <td>₱5,500</td>
                        </tr>
                        <tr>
                          <td>101st-200th</td>
                          <td>₱2,750</td>
                        </tr>
                        <tr>
                          <td>201st-400th</td>
                          <td>₱1,100</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <strong>Terms & Conditions</strong>
                  <ol>
                    <li>All time mentioned above is based on UTC+8.</li>
                    <li>
                      Once the player meets the leaderboard requirements, the
                      wins earned in previous qualified rounds during the
                      tournament will be converted into points.
                    </li>
                    <li>
                      The value of points will be rounded off to 2 decimal
                      places when calculating points.
                    </li>
                    <li>Only qualified rounds are counted in this campaign.</li>
                    <li>
                      All prizes and bets in the campaign become invalid if any
                      malfunction occurs.
                    </li>
                    <li>
                      Anyone who participates in this campaign is deemed to
                      agree with all the regulations of the campaign and the
                      casino, and is willing to abide by it, The organizer
                      reserves the right to modify and terminate this campaign
                      at any time.
                    </li>
                    <li>
                      Winners are able to claim their prizes in each
                      campaign-designated game by clicking the collect button on
                      the pop-up message after the campaign finishes. Please be
                      aware of the change in your account balance.
                    </li>
                    <li>
                      Ineligible Games: Pig Up, Bluffy Cat, Zeus Power, Cash
                      Volcano, Wild Cats Fire: Hold and Win, Hot Chilli Joker,
                      Flash Joker: Fever, Fruits & Sevens: Fever, 3 Fortune
                      Trees: Hold and Win, Nights of Fire: Hold and Win,
                      Mariachi Lock, Fruits & Joker: Fever, Fruits Fever 5
                      lines, 3 Hungry Pandas Hold and Win.
                    </li>
                  </ol>
                  <div className="promotion-tnc-cta">
                    <a
                      className="promotion-cta-btn"
                      href="https://servicebooongo.com//bngevent/event?event=202601BR&lang=en&currency=PHP"
                      target="_blank"
                    >
                      View Full T&C
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
